import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import config from '../config';
import { inputTitleClass } from '../InputTitle/styles';
import cleanProps from '../utils/cleanProps';
import Clear from './clear';
import { inputClass } from './styles';
import InputTitle from '../InputTitle';

function regLength(size) {
  return /\d+/.test(String(size)) && size > 0 ? "{0,".concat(size, "}") : '*';
}

function fillNumber(val) {
  return val.replace(/^(-)?(\.\d+)(?!=\.).*/g, '$10$2') // eslint-disable-next-line no-useless-escape
  .replace(/(-|^)0+(?=0\.?|[^0\.])/g, '$1').replace(/\.$/, '');
}

var DefaultValue = {
  type: 'text'
};

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  var _super = _createSuper2(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);
    _this.enterLock = void 0;
    _this.ref = void 0;
    _this.enterPress = void 0;

    _this.defaultInfo = function (value) {
      if (!value || value.length === 0) return null;
      var info = _this.props.info;
      var text = "".concat(value.length, " / ").concat(info);
      if (typeof info === 'number' && value.length <= info) return text;
      return new Error(text);
    };

    _this.getTrim = function () {
      var trim = _this.props.trim;
      if (trim !== undefined) return trim;
      if (config.trim !== undefined) return config.trim;
      return false;
    };

    _this.enterLock = false;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleAutoSelect = _this.handleAutoSelect.bind(_assertThisInitialized(_this));
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Input, [{
    key: "bindRef",
    value: function bindRef(el) {
      var forwardedRef = this.props.forwardedRef;
      this.ref = el;
      if (forwardedRef) forwardedRef(el);
    }
  }, {
    key: "isValidNumber",
    value: function isValidNumber(val) {
      var numType = this.props.numType;
      var noNeg = numType === 'non-negative' || numType === 'positive';
      var regExp = new RegExp("^(".concat(noNeg ? '' : '-', ")?\\d*\\.?\\d*$"), 'g');
      return regExp.test(val);
    }
  }, {
    key: "formatValue",
    value: function formatValue(val) {
      var value = val;
      var _this$props = this.props,
          type = _this$props.type,
          digits = _this$props.digits,
          integerLimit = _this$props.integerLimit,
          numType = _this$props.numType;
      var noNeg = numType === 'non-negative' || numType === 'positive';
      if (type !== 'number') return value;
      var regExp = new RegExp("^(".concat(noNeg ? '' : '-', ")?(\\d").concat(regLength(integerLimit), ")(").concat(digits !== 0 ? "\\.\\d".concat(regLength(digits)) : '', ")?.*$"), 'g');
      value = value.replace(regExp, '$1$2$3');
      return value;
    }
  }, {
    key: "fixValue",
    value: function fixValue(val) {
      var _this$props2 = this.props,
          type = _this$props2.type,
          digits = _this$props2.digits,
          autoFix = _this$props2.autoFix,
          numType = _this$props2.numType;
      if (type !== 'number' || val === '') return val;
      if (/^[.-]+$/.test(val)) return '';
      var fixVal = fillNumber(val);
      if (numType === 'positive' && Number(fixVal) <= 0) return '';

      if (digits !== undefined && autoFix) {
        if (digits > 0) {
          fixVal = parseFloat(fixVal).toFixed(digits);
        } else {
          fixVal = parseInt(fixVal, 10).toString();
        }
      }

      return fixVal;
    }
  }, {
    key: "invalidNumber",
    value: function invalidNumber(value) {
      var _this$props3 = this.props,
          digits = _this$props3.digits,
          type = _this$props3.type,
          integerLimit = _this$props3.integerLimit;
      if (type !== 'number') return false;
      var reg = '^-?';

      if (!integerLimit) {
        reg += "\\d*";
      } else if (integerLimit > 0) {
        reg += "\\d{0,".concat(integerLimit, "}");
      }

      if (digits === undefined) {
        reg += '\\.?\\d*';
      } else if (digits >= 0) {
        reg += "\\.?\\d{0,".concat(digits, "}");
      }

      reg += '$';
      reg = new RegExp(reg);
      return !reg.test(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, clearClick) {
      var _this$props4 = this.props,
          type = _this$props4.type,
          clearable = _this$props4.clearable,
          coin = _this$props4.coin;

      if (clearClick) {
        this.ref.focus();
        if (typeof clearable === 'function') clearable();
      }

      var _ref = e.target,
          value = _ref.value;

      if (clearClick && this.props.clearToUndefined) {
        this.props.onChange(value);
        return;
      }

      if (type === 'number') {
        if (typeof value !== 'number') {
          value = String(value).replace(/。/g, '.');

          if (coin) {
            value = value.replace(/,/g, '');
          }
        }

        if (!this.isValidNumber(value)) {
          return;
        }

        value = this.formatValue(value);
      }

      this.props.onChange(value);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var onKeyDown = this.props.onKeyDown;
      if (e.keyCode === 13) this.enterPress = true;
      if (onKeyDown) onKeyDown(e);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      var _this$props5 = this.props,
          onKeyUp = _this$props5.onKeyUp,
          onEnterPress = _this$props5.onEnterPress;

      if (this.enterPress && e.keyCode === 13 && onEnterPress) {
        onEnterPress(e.target.value, e);
        this.enterPress = false;
      }

      if (onKeyUp) onKeyUp(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var _ref2 = e.target,
          value = _ref2.value;
      var _this$props6 = this.props,
          forceChange = _this$props6.forceChange,
          onChange = _this$props6.onChange,
          onBlur = _this$props6.onBlur,
          clearToUndefined = _this$props6.clearToUndefined;
      var newVal = this.fixValue(value);
      var shouldKeepUndefined = clearToUndefined && newVal === '' && this.props.value === undefined;

      if (!shouldKeepUndefined && !this.invalidNumber(newVal)) {
        if (this.getTrim()) newVal = newVal.trim();
        var change = forceChange || onChange; // @ts-ignore cancelBlurChange 内部属性

        if (!this.props.cancelBlurChange) change(newVal);
        e.target.value = newVal;
      }

      if (onBlur) onBlur(e);
    }
  }, {
    key: "handleAutoSelect",
    value: function handleAutoSelect(event) {
      var onFocus = this.props.onFocus;
      var autoSelect = this.props.autoSelect;

      if (autoSelect) {
        ;
        event.currentTarget.select();
      }

      if (typeof onFocus === 'function') {
        onFocus(event);
      }
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      var info = this.props.info;
      var notNumber = typeof info !== 'number';
      if (typeof info !== 'function' && notNumber) return null;
      var textInfo = notNumber ? info : this.defaultInfo;
      var res = textInfo(this.props.value); // empty

      if (!res) return null;
      var isError = res instanceof Error;
      var text = isError ? res.message : res;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "info",
          style: {
            minWidth: 'auto'
          },
          className: inputClass('bottom-right', isError ? 'error' : 'tip')
        }, text)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          type = _this$props7.type,
          defaultValue = _this$props7.defaultValue,
          digits = _this$props7.digits,
          className = _this$props7.className,
          clearable = _this$props7.clearable,
          htmlName = _this$props7.htmlName,
          forceChange = _this$props7.forceChange,
          onEnterPress = _this$props7.onEnterPress,
          forwardedRef = _this$props7.forwardedRef,
          innerTitle = _this$props7.innerTitle,
          inputFocus = _this$props7.inputFocus,
          clearToUndefined = _this$props7.clearToUndefined,
          placeholder = _this$props7.placeholder,
          coin = _this$props7.coin,
          cancelBlurChange = _this$props7.cancelBlurChange,
          other = _objectWithoutProperties(_this$props7, ["type", "defaultValue", "digits", "className", "clearable", "htmlName", "forceChange", "onEnterPress", "forwardedRef", "innerTitle", "inputFocus", "clearToUndefined", "placeholder", "coin", "cancelBlurChange"]);

      var value = this.props.value == null || this.props.value === undefined ? '' : this.props.value;
      var needClearUndefined = clearToUndefined && this.props.value !== undefined;
      var showClear = !other.disabled && clearable && (value !== '' || needClearUndefined);
      var mc = classnames(className, showClear && inputClass('clearable'), innerTitle && inputTitleClass('hidable', 'item'));
      var isNumber = className && className.indexOf(inputClass('number')) > -1;
      return [
      /*#__PURE__*/
      React.createElement(InputTitle, {
        className: isNumber ? inputClass('number-title-box') : undefined,
        key: "input",
        innerTitle: innerTitle,
        open: !!inputFocus || !!value
      },
      /*#__PURE__*/
      React.createElement("input", Object.assign({}, cleanProps(other), {
        placeholder: needClearUndefined ? '' : placeholder,
        className: mc || undefined,
        name: other.name || htmlName,
        type: type === 'password' ? type : 'text',
        value: value,
        ref: this.bindRef,
        key: "input",
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        onFocus: this.handleAutoSelect
      }))), showClear &&
      /*#__PURE__*/
      React.createElement(Clear, {
        onClick: this.handleChange,
        key: "close",
        clearResult: needClearUndefined ? undefined : ''
      }), this.renderInfo()];
    }
  }]);

  return Input;
}(PureComponent);

Input.defaultProps = DefaultValue;
export default Input;